/* Starts the custom Google OAuth flow (user's own GCP client — no Emergent
   branding on the consent screen).
   REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
   THIS BREAKS THE AUTH. */
import { api } from "./api";
import { toast } from "sonner";

export async function startGoogleSignIn() {
  try {
    const { data } = await api.get("/auth/google/config");
    if (!data.client_id) {
      toast.error("Google sign-in is not configured yet");
      return;
    }
    const params = new URLSearchParams({
      client_id: data.client_id,
      redirect_uri: window.location.origin + "/auth/google",
      response_type: "code",
      scope: "openid email profile",
      prompt: "select_account",
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  } catch {
    toast.error("Could not start Google sign-in — try again");
  }
}
